export default __webpack_public_path__ + "static/media/img56.b7181ee4.jpg";